export default __webpack_public_path__ + "static/media/ranger.8d69121a.png";